// Подписи и цвета статусов заявки на возврат (макет «Профиль», раздел
// «Возвраты»): «На рассмотрении» — тёмный, «Верните товар» — #FF8D28.
import type { BuyerReturnDetail, BuyerReturnTab } from "@/api";

export const RETURN_TAB_LABEL: Record<BuyerReturnTab, string> = {
	active: "Активные",
	dispute: "Открыт спор",
	archive: "Архив",
};

export const tabOfReturn = (r: BuyerReturnDetail): BuyerReturnTab =>
	r.dispute ? "dispute" : r.status === "refunded" || r.status === "rejected" ? "archive" : "active";

export const isCancelledByBuyer = (r: BuyerReturnDetail) =>
	r.status === "rejected" && r.lines.length > 0 && r.lines.every((l) => Boolean(l.cancelledAt));

export function returnStatusLabel(r: BuyerReturnDetail): { label: string; className: string } {
	if (r.dispute) {
		if (r.dispute.status === "open") return { label: "Открыт спор", className: "text-[#E1574F]" };
		return {
			label:
				r.dispute.outcome === "buyer"
					? "Спор решён в вашу пользу"
					: r.dispute.outcome === "seller"
						? "Спор решён в пользу продавца"
						: "Спор закрыт",
			className: "text-[#1F1F1F]",
		};
	}
	switch (r.status) {
		case "requested":
			return { label: "На рассмотрении", className: "text-[#1F1F1F]" };
		case "approved":
			return { label: "Верните товар", className: "text-[#FF8D28]" };
		case "received":
			return { label: "Товар у продавца", className: "text-[#32D47D]" };
		case "refunded":
			return { label: "Деньги возвращены", className: "text-[#32D47D]" };
		case "rejected":
			return isCancelledByBuyer(r)
				? { label: "Заявка отменена", className: "text-[#1F1F1F]/48" }
				: { label: "Отклонена продавцом", className: "text-[#E1574F]" };
	}
}
